module.exports = __webpack_public_path__ + "static/media/af-unscratche.58b25408.jpg";